export interface IDonorExportability {
    id: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorType: string,
    abo: string,
    swap: string,
    donorDonationStartDate: Date,
    donorDonationEndDate: Date,
    typingDate: Date,
    hlaDate: Date,
    aboDate: Date,
    medChartDate: Date,
    cryoOrderedDate: Date,
    cryoUpdatedDate: Date,
    isChainStarter: boolean,
    donorIsActive: boolean,
    donorIsExportable: boolean,
    isTransplanted: boolean,
    isRecipientComplete: string,
    hasValidDateOfBirth: boolean,
    hasAbo: boolean,
    isAboConfirmed: boolean,
    hasDonationStartDate: boolean,
    hasDonationEndDate: boolean,
    isHlaComplete: boolean,
    hlaConfirmation: boolean,
    hasKidneySize: boolean,
    hasCryo: boolean,
    hasCTScan: boolean,
    hasSamples: boolean,
    hasAdpForm: boolean,
    hasCtReport: boolean,
    hasTyping: boolean,
    hasMedChart: boolean,
    donorIsViableBridge: boolean,
    hasDonorTbStatus: boolean,
    hasWhichKidney: boolean,
    hasNumberOfVeins: boolean,
    hasNumberOfArteries: boolean,
    hasNumberofUreters: boolean,
    donorIsAdp: boolean,
    donorIsWorkedUp: boolean,
    hasAntiHcv: boolean,
    hasDonorHiv: boolean,
    hasDonorEBV: boolean,  
    hasDonorCMV: boolean,
    hasDonorHepbAntibody: boolean,
    hasDonorHepbAntigen: boolean,
    hasDonorRprVdrl: boolean,
    incompleteWeight: number
    donorDonationStartDateDisplay: string,
    donorDonationEndDateDisplay: string,
    typingDateDisplay: string,
    hLADateDisplay: string,
    aboDateDisplay: string,
    medChartDateDisplay: string,
    cryoOrderedDateDisplay: string,
    cryoUpdatedDateDisplay: string,
    firstExportableDateDisplay: string,
}


